import { useQuery } from "react-query";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import { allKontakDaruratKey } from "../../mutations/KontakDarurat/useFetchKontakDarurat";
import { KontakDaruratResponse } from "../../../../models/KontakDarurat";
import getQueryClient from "../../queryClient";
import { checkProfileKey } from "../User/useFetchCheckProfile";
import ApiClient from "../../../apiClient";

export async function allKontakDarurat(): Promise<KontakDaruratResponse[]> {
    const res = await ApiClient.get(`/AllEmergencyContact`);
    return res.data;
}

export default function useFetchAllKontakDarurat() {
    getQueryClient().invalidateQueries(checkProfileKey);
    return useQuery([allKontakDaruratKey], queryWrapper(allKontakDarurat));
}
